import { useState } from 'react';

import toast from 'react-hot-toast';

function BarraBuscaCpf({ setCpfPai }) {

    console.log('### Iniciando BarraBuscaCpf ###');

    const [cpf, setCpf] = useState('')

    console.log(cpf);

    const buscaCPF = async () => {

        if (cpf == null) {
            toast.error('Digite o CPF na barra de busca')
            return
        }

        if (cpf.length !== 11) {
            toast.error('O CPF deve conter 11 dígitos')
            return
        }

        setCpfPai(cpf)

    }

    return (
        <nav className="navbar navbar-light bg-light w-100">

            <div className="container-fluid">
                <a className="navbar-brand">CPF</a>
                <form className="d-flex">
                    <input
                        className="form-control me-2"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                        onBlur={(e) => {
                            const somenteNumeros = e.target.value.replace(/\D/g, "");
                            setCpf(somenteNumeros);
                        }}
                        defaultValue={cpf}
                    />
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={buscaCPF}
                    >
                        Buscar
                    </button>
                </form>
            </div>
        </nav>
    )
}

export default BarraBuscaCpf